var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 176,
    viewBox: "0 0 175 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.04 81.8362L83.0045 101.801C84.9571 103.753 88.123 103.753 90.0756 101.801L165.04 26.8362",
    stroke: "#8FCA00",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.782 77.517C24.4942 39.3662 60.0522 13.0697 98.2029 18.782C103.119 19.518 107.7 16.1296 108.436 11.2139C109.172 6.29811 105.784 1.71643 100.868 0.980395C52.8861 -6.20393 8.16472 26.8693 0.980395 74.8515C-6.20394 122.834 26.8693 167.555 74.8515 174.739C122.834 181.924 167.555 148.851 174.739 100.868C175.475 95.9525 172.087 91.3709 167.171 90.6348C162.256 89.8988 157.674 93.2871 156.938 98.2029C151.226 136.354 115.668 162.65 77.517 156.938C39.3662 151.226 13.0697 115.668 18.782 77.517Z",
    fill: "#8FCA00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green_check.8dd69c0ddb5681c9bc0a9b30bd8fccad.svg";
export { ForwardRef as ReactComponent };